import React from 'react';
import PropTypes from 'prop-types';
import { VIDEO_CONF_BY_ID } from './constants.js';
import messages from './messages.js';

function VideoIcon(props) {
  const { info, className } = props;
  if (!info) {
    return null;
  }
  const { provider } = info;
  const { icon, label } = VIDEO_CONF_BY_ID[provider];
  if (!icon) {
    return null;
  }
  return (
    <img src={icon} alt={messages[label]} className={className} />
  );
}

VideoIcon.propTypes = {
  info: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string,
};

export default VideoIcon;
